import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { decimalToStep } from '@ui/util/decimal-transforms';
import { get, useFormContext, useWatch } from 'react-hook-form';

export function CustomerPotentialForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const decimalPlaces = useWatch({
    name: 'decimalPlaces',
    control: form.control,
    defaultValue: '2',
  }) as string;

  const lowFieldPath = fieldPath('low');
  const mediumFieldPath = fieldPath('medium');
  const highFieldPath = fieldPath('high');

  const step = decimalToStep(decimalPlaces);

  return (
    <Flex as="fieldset" direction={{ base: 'column', md: 'row' }} gap={2}>
      <FormControl
        isInvalid={!!get(form.formState.errors, lowFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={lowFieldPath}>Low:</FormLabel>

        <Input
          {...form.register(lowFieldPath)}
          type="number"
          inputMode="numeric"
          id={lowFieldPath}
          placeholder="Low"
          step={step}
        />

        <ErrorMessage
          name={lowFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, mediumFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={mediumFieldPath}>Medium:</FormLabel>

        <Input
          {...form.register(mediumFieldPath)}
          type="number"
          inputMode="numeric"
          id={mediumFieldPath}
          placeholder="Medium"
          step={step}
        />

        <ErrorMessage
          name={mediumFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, highFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={highFieldPath}>High:</FormLabel>

        <Input
          {...form.register(highFieldPath)}
          type="number"
          inputMode="numeric"
          id={highFieldPath}
          placeholder="High"
          step={step}
        />

        <ErrorMessage
          name={highFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </Flex>
  );
}
